import { Pipe, PipeTransform } from '@angular/core';
import {DocumentosPendentes} from "app/shared/models/financas/documentos-por-regularizar/documentos-por-regularizar";
@Pipe({
  name: 'docStatus',
  pure: true
})
export class DocStatusPipe implements PipeTransform {
  // https://dev-back.kiami.ao/fin/api/v1/documentos/estadosPagamento
 // F - facturado - E- emitido - T - retificado, 
 public transform(doc: DocumentosPendentes): any {
    if(doc && doc.codDocumento){
      if(doc.codDocumento === 'A'){ // Anulado
        return "red-500-fg text-white";
      }
      if(doc.codDocumento === 'P'){ // Aprovado
        return "bg-secundary text-white";
      }
      if(doc.codDocumento === 'N'){ // Em análise"
        return "bg-secundary text-white";
      }
      if(doc.codDocumento === 'E'){ // Emitido
        return "bg-secundary text-white";
      }
      if(doc.codDocumento === 'F'){ // Facturado
        return "bg-secundary text-white";
      }
      if(doc.codDocumento === 'C'){ // Parcialmente Facturado
        return "bg-secundary text-white";
      }
      if(doc.codDocumento === 'D'){ // Pendente
        return "bg-secundary text-white";
      }
      if(doc.codDocumento === 'R'){ // Rectificado (Parcialmente)
        return "bg-secundary text-white";
      }
      if(doc.codDocumento === 'T'){ // Rectificado (Totalmente)
        return "bg-secundary text-white";
      }
      if(doc.codDocumento === 'J'){ // Rejeitado
        return "bg-secundary text-white";
      }
    }
    return "";
  }

}
